<template>
  <div>
    <div class="col-md-12 form-wrapper">
      <h2>Register</h2>
      <form id="registerForm" @submit.prevent="register">
        <div class="form-group">
          <label for="username">Username</label>
          <input
            type="string"
            id="username"
            v-model="username"
            name="username"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input
            type="password"
            id="password"
            v-model="password"
            name="password"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="inviteCode">Invite Code</label>
          <input
            type="string"
            id="inviteCode"
            v-model="inviteCode"
            name="inviteCode"
            class="form-control"
          />
        </div>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="pricacyPolicyCheck"
            v-model="privacyAgreement"
          />
          <label class="form-check-label" for="pricacyPolicyCheck"
            >I have read and agreed to the privacy policy.</label
          >
        </div>

        <button class="btn btn-success btn-lg" type="submit">
          Create Account
        </button>
      </form>
    </div>
    <span
      >Already have an account?
      <router-link class="btn btn-link" :to="{ name: 'login' }"
        >Login</router-link
      ></span
    >
    <div class="mt-5 text-muted small">
      <router-link to="/imprint">Imprint</router-link> |
      <router-link to="/privacy-policy">Privacy Policy</router-link>
    </div>
    <div>
      <div class="alert alert-danger mt-2" role="alert" v-if="registerError">
        {{ this.errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { server } from "@/utils/helper";
import axios from "axios";
export default {
  data() {
    return {
      username: "",
      password: "",
      inviteCode: "",
      registerError: false,
      privacyAgreement: false,
      errorMessage: "",
    };
  },
  methods: {
    async register() {
      let newAccount = {
        username: this.username.trim(),
        password: this.password.trim(),
        inviteCode: this.inviteCode.trim(),
      };

      if (
        newAccount.username == "" ||
        newAccount.password == "" ||
        newAccount.inviteCode == ""
      ) {
        this.registerError = true;
        this.errorMessage = "Please fill out all fields.";
        return;
      }

      if (!this.privacyAgreement) {
        this.registerError = true;
        this.errorMessage =
          "Please confirm you have read and accepted the privacy policy.";
        return;
      }

      await this._submitToServer(newAccount);
    },
    async _submitToServer(data) {
      try {
        await axios.post(`${server.baseUrl}/auth/register`, data);
      } catch (error) {
        this.registerError = true;
        if (error.response?.status === 409) {
          this.errorMessage = "A user with this username already exists.";
        } else if (error.response?.status === 403) {
          this.errorMessage = error.response?.data?.message;
          console.log(this.errorMessage);
        } else {
          this.errorMessage = "Error creating your user. Please try again.";
        }
        console.log(error);
        return;
      }

      try {
        const loginResponse = await axios.post(`${server.baseUrl}/auth/login`, {
          password: data.password,
          username: data.username,
        });
        localStorage.setItem("jwt", loginResponse.data.access_token);
        router.push({ name: "home" });
      } catch (error) {
        this.registerError = true;
        if (error.response?.status === 404) {
          this.errorMessage = "No user with this username found.";
        } else if (error.response?.status === 401) {
          this.errorMessage = "Incorrect password.";
        } else {
          this.errorMessage = "Error logging in. Please try again.";
        }
        console.log(error);
      }
    },
  },
};
</script>
